import { createFileRoute } from '@tanstack/react-router';
import { EnterprisePoliciesPage } from 'src/apps/fleet/app/pages/EnterprisePoliciesPage';

export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/policies'
)({
  component: () => <EnterprisePoliciesPage />,
});
